import { STATES } from 'common/domain/states';

class LoansDetailRequestItController {
  constructor($state, $stateParams) {
    'ngInject';
    this.state = $state;
    this.loanId = $stateParams.loanId;

    this.redirectFunctions = {
      'my-creditworthiness': () => this.state.go(STATES.LOANS.CREDITWORTHINESS),
      'my-loans': () => this.state.go(STATES.LOANS.MY_LOANS),
      'sign-up': () => this.state.go(STATES.LOANS.SIGN_UP, { loanId: this.loanId }),
      'need-a-loan': () => this.state.go(STATES.LOANS.NEED_A_LOAN),
    };
  }
}

export default LoansDetailRequestItController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailRequestIt/loansDetailRequestIt.controller.js